import { Order } from '../../../ts/helpers/Order';
import { OrderKeys } from '../../../ts/models/OrderKeys';
import { SortOptions } from '../../../ts/models/sort/CommonSortOptions';
import { OptionsDictionary } from '../../../ts/models/sort/SortOptionDefinitions';
import { IOrderClause } from '../../../ts/ServerApi/types/IOrderClause';

interface DatasourceSubspaceSortOptions {
  defaultOrder: IOrderClause[];
  options: OptionsDictionary;
}

export const DatasourceSubspaceConnectionsSortOptions: DatasourceSubspaceSortOptions = {
  defaultOrder: [Order.asc(OrderKeys.connectionTypeDisplayName)],
  options: {
    'type': SortOptions.connectionType
  }
};
